<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_STAT_OCCUR_DT')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="rangeDate"
              v-model="periodDT"
              @confirm="onChangedPeriodDT"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BBS_TYP')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="boardTypeOptions"
              :defaultOption="'all'"
              :selected="frame0.selectData.COD_BBS_TYP_CD"
              codeId="COD_BBS_TYP_CD"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="searchTypeOptions"
              :defaultOption="'all'"
              :selected="frame0.selectData.COD_BBS_SCR_CON"
              codeId="COD_BBS_SCR_CON"
              class="width60"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="frame0.searchCondText"
              placeholder=""
              maxlength="100"
              :disabled="false"
              :readonly="false"
              @input="specialChar($event,'searchCondText')"
              @keyup.enter="searchBoardStatistics"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="resetFunction"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="searchBoardStatistics"
          >
            {{ $t('MSG_BTN_SRCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :columns="gridColumns0"
        :hideHeader="false"
        :initial-pagesize="10"
        :showCountControl="true"
        :showDisplayCountControl="true"
        :dataset="'dataset0'"
        :rowMovable="false"
        :multiselect="false"
        :pageable="false"
      >
        <div class="btn_wrapR">
          <sui-button
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="downloadExcel"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM'];
export default {
  name: 'PGE_CLB_00009', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      // Codes
      frame0: {
        selectData: {
          COD_BBS_TYP_CD: { key: '', label: '' },
          COD_BBS_SCR_CON: { key: '', label: '' },
        },
        searchCondText: '',
      },
      startDate: '',
      endDate: '',
      periodDT: {},
      searchCondText: '',
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_SN'),
        datafield: '',
        cellsrenderer: (row, column, value) => {
          return '<div style="margin: 8.2px;">' + (row + 1) + '</div>';
        },
        width: 60,
      }, {
        text: this.$t('MSG_TXT_STAT_OCCUR_DT'),
        datafield: 'firstRegistrationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.dataset0, this.$refs.grdList),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: 130,
      }, {
        text: this.$t('MSG_TXT_BBS_ID'),
        datafield: 'bbsBoardName',
        width: 120,
      }, {
        text: this.$t('MSG_TXT_BBS_NM'),
        datafield: 'bbsId',
      }, {
        text: this.$t('MSG_TXT_BBS_TYP'),
        datafield: 'bbsBoard',
        width: 120,
      }, {
        text: this.$t('MSG_TXT_USR_ID'),
        datafield: 'userNm',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            loginId: 'loginId',
          }, this.dataset0, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_DEPT'),
        datafield: 'division',
        width: 180,
      }, {
        text: this.$t('MSG_TXT_CRE_CNT'),
        datafield: 'createLogCount',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SRCH_CNT'),
        datafield: 'searchLogCount',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_MOD_CNT'),
        datafield: 'modifiedLogCount',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_DEL_CNT'),
        datafield: 'deleteLogCount',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_ANS_CNT'),
        datafield: 'answeredLogCount',
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: '',
      type: 'string',
      map: '',
    }, {
      name: 'bbsBoard',
      type: 'string',
      map: 'bbsBoard',
    }, {
      name: 'bbsBoardName',
      type: 'string',
      map: 'bbsBoardName',
    }, {
      name: 'bbsId',
      type: 'string',
      map: 'bbsId',
    }, {
      name: 'bbsBoardTitle',
      type: 'string',
      map: 'bbsBoardTitle',
    }, {
      name: 'bbsCatgGrpNm',
      type: 'string',
      map: 'bbsCatgGrpNm',
    }, {
      name: 'division',
      type: 'string',
      map: 'division',
    }, {
      name: 'userNm',
      type: 'string',
      map: 'userNm',
    }, {
      name: 'createLogCount',
      type: 'string',
      map: 'createLogCount',
    }, {
      name: 'searchLogCount',
      type: 'string',
      map: 'searchLogCount',
    }, {
      name: 'modifiedLogCount',
      type: 'string',
      map: 'modifiedLogCount',
    }, {
      name: 'deleteLogCount',
      type: 'string',
      map: 'deleteLogCount',
    }, {
      name: 'answeredLogCount',
      type: 'string',
      map: 'answeredLogCount',
    }, {
      name: 'firstRegistrationDTM',
      type: 'string',
      map: 'firstRegistrationDTM',
    }, {
      name: 'loginId',
      type: 'string',
      map: 'loginId',
    },
    ],
  }],
  mounted() {
    this.periodDT = {
      from: utils.toStringByFormat(utils.addDay(utils.now('YYYY-MM-DD'), -7), 'YYYY-MM-DD'),
      to: utils.now('YYYY-MM-DD'),
    };
    this.startDate = utils.toStringByFormat(this.periodDT.from, 'YYYYMMDD') + '000000';
    this.endDate = utils.toStringByFormat(this.periodDT.to, 'YYYYMMDD') + '235959';
  },
  methods: {
    onChangedPeriodDT() {
      this.startDate = utils.toStringByFormat(this.periodDT.from, 'YYYYMMDD') + '000000';
      this.endDate = utils.toStringByFormat(this.periodDT.to, 'YYYYMMDD') + '235959';
    },
    resetFunction() {
      this.$refs.boardTypeOptions.reset();
      this.$refs.searchTypeOptions.reset();
      this.frame0.searchCondText = '';
      this.periodDT = {
        from: utils.toStringByFormat(utils.addDay(utils.now('YYYY-MM-DD'), -7), 'YYYY-MM-DD'),
        to: utils.now('YYYY-MM-DD'),
      };
      this.startDate = utils.toStringByFormat(this.periodDT.from, 'YYYYMMDD');
      this.endDate = utils.toStringByFormat(this.periodDT.to, 'YYYYMMDD');
    },
    searchBoardStatistics() {
      if (!this.$refs.rangeDate.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return false;
      }

      if (!this.startDate && !this.endDate && !this.$refs.searchTypeOptions.currentSelected.codeId) {
        utils.messageBox('warning', this.$t('MSG_ALT_REQ_DT_SRCH_COND'), null, null);
        this.dataset0.setRawData('');
      } else {
        if (this.$refs.searchTypeOptions.currentSelected.codeId) {
          let initialdate = utils.toStringByFormat(this.startDate, 'YYYY-MM-DD');
          this.periodDT.from = utils.toStringByFormat(utils.addMonth(initialdate, 3), 'YYYY-MM-DD');
          if (utils.getDayOffset(this.periodDT.to, this.periodDT.from) > -1) {
            utils.messageBox('warning', this.$t('MSG_ALT_SRCH_NOT_OVER_3M'));
          } else {
            this.searchBoardStatisticsApi();
          }
        } else if (!this.$refs.searchTypeOptions.currentSelected.codeId) {
          this.periodDT.from = utils.toStringByFormat(this.startDate, 'YYYY-MM-DD');
          if (utils.getDayOffset(this.periodDT.to, this.periodDT.from) > 7) {
            utils.messageBox('warning', this.$t('MSG_ALT_SRCH_NOT_OVER_1W'));
          } else {
            this.searchBoardStatisticsApi();
          }
        }
      }
    },
    searchBoardStatisticsApi() {
      const queryParams = {
        statsCreatedStartDateTime: this.startDate || '',
        statsCreatedFinishDateTime: this.endDate || '',
        bulletinBoardType: this.$refs.boardTypeOptions.currentSelected.codeId || '',
        bullBoardSearchCond: this.$refs.searchTypeOptions.currentSelected.codeId || '',
        bullBoardSearchCondValue: this.searchCondText || '',
      };
      http.request('PGE_CLB_00009', 'DTS_CLB_00048', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);
        this.dataset0.setRawData(res.data);
      });
    },
    downloadExcel() {
      const sPageId = this.contextPageId;
      const objGridColumns = this.gridColumns0;
      const objGridDataset = this.dataset0;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `excel_${sToday}.xlsx`;
      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    },
    specialChar(event, name) {
      const searchFieldNewText = this.frame0[name];
      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_SPECL_CHAR'), null, () => {
          this.frame0[name] = this[name];
        });
      } else {
        this[name] = searchFieldNewText;
      }
    },
  },
};
</script>
<style scoped>
</style>
